import { FlexGrid, Image, Text } from '@gasbuddy/react-components';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './GetStarted.module.css';
import PayPrograms from '../../constants/payPrograms';

const cx = classnames.bind(styles);

const ENROLLMENT_STEPS_SUMMARY = [
  {
    icon: '//static.gasbuddy.com/web/icons/pwgb-avatar-icon.svg',
    iconAlt: 'Customer',
    title: 'Customer Details',
    description: 'We need your legal name, driver\'s license, and income information to verify your identity and enable access to your card.',
  },
  // {
  //   icon: '//static.gasbuddy.com/web/icons/pwgb-home-icon.svg',
  //   iconAlt: 'Address',
  //   title: 'Shipping Address',
  //   description: 'We need your shipping address so we know where to send your card.',
  // },
  {
    icon: '//static.gasbuddy.com/web/icons/pwgb-bank-icon.svg',
    iconAlt: 'Bank',
    title: 'Securely link your checking account',
    description: 'We\'ll connect your card to your account so you can start saving.',
  },
  {
    icon: '//static.gasbuddy.com/web/icons/pwgb-clock-icon.svg',
    iconAlt: 'Payment Options',
    title: 'Payment Options',
    description: 'Select your preferred ACH payment method.',
  },
];

const [
  CustomerDetailsStep,
  // ShippingAddressStep,
  BankStep,
  PaymentOptionsStep,
] = ENROLLMENT_STEPS_SUMMARY;

const EnrollmentStep = ({ icon, iconAlt, title, description }) => (
  <div className={cx('enrollmentStepOverview')}>
    <div className={cx('enrollmentStepIconContainer')}>
      <Image
        src={icon}
        alt={iconAlt}
        className={cx('enrollmentStepIcon')}
      />
    </div>
    <div className={cx('enrollmentStepSummary')}>
      <Text bold color="midnight">
        {title}
      </Text>
      <Text as="p">
        {description}
      </Text>
    </div>
  </div>
);
EnrollmentStep.propTypes = {
  icon: PropTypes.string.isRequired,
  iconAlt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default function EnrollmentStepsOverview({
  payProgram,
}) {
  return (
    <React.Fragment>
      {payProgram === PayPrograms.Free ? (
        <Text as="p">
          You are steps away from unlocking major savings on every gallon.
          We just need a few more details from you before we can ship your Pay with GasBuddy+<sup>&trade;</sup> card:
        </Text>
      ) : (
        <Fragment>
          <Text as="p">
            To unlock <strong>{payProgram} membership savings and perks,</strong> you must first sign up for
            Pay with GasBuddy+<sup>&trade;</sup> to receive a fuel savings card.
            This card gives you access to {payProgram} member savings at the pump and inside the station.
          </Text>
          <Text as="p">
            We just need a few more details from you before we can ship your Pay with GasBuddy+<sup>&trade;</sup> card:
          </Text>
        </Fragment>
      )}
      <FlexGrid container>
        <FlexGrid.Column tablet={12}>
          <EnrollmentStep
            icon={CustomerDetailsStep.icon}
            iconAlt={CustomerDetailsStep.iconAlt}
            title={CustomerDetailsStep.title}
            description={CustomerDetailsStep.description}
          />
          <EnrollmentStep
            icon={BankStep.icon}
            iconAlt={BankStep.iconAlt}
            title={BankStep.title}
            description={BankStep.description}
          />
          {payProgram === PayPrograms.Free && (
            <EnrollmentStep
              icon={PaymentOptionsStep.icon}
              iconAlt={PaymentOptionsStep.iconAlt}
              title={PaymentOptionsStep.title}
              description={PaymentOptionsStep.description}
            />
          )}
        </FlexGrid.Column>
      </FlexGrid>
    </React.Fragment>
  );
}

EnrollmentStepsOverview.propTypes = {
  payProgram: PropTypes.string,
};

EnrollmentStepsOverview.defaultProps = {
  payProgram: PayPrograms.Free,
};
